import {Component, OnInit} from '@angular/core';
import {FieldConfig} from "@biletix/core/models/base/field-config.model";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'btx-date',
  templateUrl:'./btx-date.component.html',
  styleUrls: ['./btx-date.component.scss'],
  standalone: false
})
export class BtxDateComponent implements OnInit {


  field: FieldConfig | any;

  group: FormGroup | any;

  constructor() {
  }

  ngOnInit(): void {
  }

}
